import { BrandTranslations } from 'typings/brands'

// This translations are temporary, update once received the details
export const translations: BrandTranslations = {
  en: {
    common: {
      Addressee: '%addressee%',
      'Address Line 1': '%addressLine1%',
      'Address Line 2': '%city%, %state% %zipCode%'
    },
    customNeedAssistance: {
      'Commercial Credit Card Services': 'Commercial Credit Card Services',
      'Commercial Credit Card': 'Commercial Credit Card',
      'Monday - Friday': 'Monday - Friday',
      '08:00 AM - 01:00 AM EST': '08:00 AM - 01:00 AM EST',
      'Saturday & Sunday': 'Saturday & Sunday',
      '09:00 AM - 10:00 PM EST': '09:00 AM - 10:00 PM EST'
    },
    creditServicesList: {
      'Request Copies of BRAND receipt with Buyer Signature':
        'Request Copies of Phillips 66® - Conoco® - 76® receipt with Buyer Signature'
    },
    csrNumber: {
      'Please call Credit Services': 'Please call Credit Services at',
      'We will assist you':
        'and we will assist you with restoring your account access'
    },
    editUserInfo: {
      'Credit service': 'Customer Care'
    },
    registration: {
      pageTitle:
        'Register for Phillips 66® - Conoco® - 76® Commercial Credit Card'
    },
    frequentlyAskedQuestions: {
      'Frequently Asked Questions': 'Frequently Asked Questions',
      'Login Questions': 'Login Questions',
      Payments: 'Payments',
      Invoices: 'Invoices',
      'Technical Help': 'Technical Help',
      'Interest Charges and Late Fees': 'Interest Charges and Late Fees',
      'Web Page Issues': 'Web Page Issues',
      'Close Account': 'Close Account',
      'Contact Us': 'Contact Us',
      'Update account Information': 'Update account Information',
      'Account Activity': 'Account Activity',
      'Replacement Cards': 'Replacement Cards',
      'Security Information': 'Security Information',
      Credit: 'Credit',
      'Tax Exemption': 'Tax Exemption',
      'Online Message Center': 'Online Message Center',
      'Sams Club Rewards': `Sam's Club Rewards`
    },
    faqLoginQuestions: {
      'Why do I need to enter personal information?':
        'Why do I need to enter personal information?',
      'Is the information that I enter secure?':
        'Is the information that I enter secure?'
    },
    faqLoginAnswers: {
      'We require you to provide us personal information...':
        'We require you to provide us personal information to login to ensure that your account is protected from unauthorized access.',
      'Yes, we use SSL encryption, an industry standard, to help...':
        'Yes, we use SSL encryption, an industry standard, to help protect your account information from unauthorized access. When your browser is in secure mode, you will notice an unbroken key or lock at the bottom of the page.'
    },
    faqPaymentQuestions: {
      'What should I do if a payment I sent has not been posted?':
        'What should I do if a payment I sent has not been posted?',
      'What methods of payment can I use to pay my bill?':
        'What methods of payment can I use to pay my bill?',
      'Where do I send my payments?': 'Where do I send my payments?',
      'Can I make a payment at a Phillips 66 location?':
        'Can I make a payment at a Phillips 66 location?',
      'Can I get my payment due date changed?':
        'Can I get my payment due date changed?',
      'The payment posted on my account was for an incorrect amount?':
        'The payment posted on my account was for an incorrect amount?',
      'What is AutoPay?': 'What is AutoPay?'
    },
    faqPaymentAnswers: {
      'If your payment has not been posted...':
        'If your payment has not been posted, please check with your bank to see if the check has been cashed. If it has, please contact Customer Service at %customerCare%.',
      'You can make a One-Time Payment or schedule AutoPay...':
        'You can make a One-Time Payment or schedule AutoPay on the Online Credit Center. We accept checks drawn on U.S. financial institutions, money orders,  Non-Synchrony Bank Branded U.S.-based Mastercard and Visa debit cards, or electronic payments through online bill services.',
      'You can send your payments to the following address:':
        'You can send your payments to the following address:',
      'Make checks payable to:': 'Make checks payable to:',
      'Phillips 66/SYNCB': 'Phillips 66/SYNCB',
      'No, you can make a One-Time Payment or...':
        'No, you can make a One-Time Payment or schedule AutoPay on the Online Credit Center. We accept checks drawn on U.S. financial institutions, money orders,  Non-Synchrony Bank Branded U.S.-based Mastercard and Visa debit cards, or electronic payments through online bill services.',
      'Yes, please contact customer service at...':
        'Yes, please contact customer service at %customerCare% for assistance.',
      'If your statement shows that your payment was received...':
        'If your statement shows that your payment was received, but it is for a different amount than you sent, please accept our apology for any inconvenience caused by this matter. In order to correct any difference in the amount that should have been credited, please contact customer service at %customerCare% or send bank verification to the following address:',
      'Payments Research': 'Payments Research',
      'Please follow the instructions below:':
        'Please follow the instructions below:',
      'If the amount posted to your account was LESS...':
        'If the amount posted to your account was LESS THAN the amount the check was written for please pay the difference.',
      'If the amount posted to your account was MORE...':
        'If the amount posted to your account was MORE THAN the amount the check was written for, please contact your bank to have the error corrected.',
      'AutoPay withdraws the payment amount you...':
        'AutoPay withdraws the payment amount you specify every month from your designated payment account on your payment due date. The payment amounts you can choose from are: statement balance, minimum payment or another amount. You can set up AutoPay by selecting “Schedule a Payment” under the “Payments” section.'
    },
    faqTechnicalHelpQuestions: {
      'Browser Requirements and Compatibility':
        'Browser Requirements and Compatibility',
      'Are there any scheduled times when online customer service is unavailable?':
        'Are there any scheduled times when online customer service is unavailable?'
    },
    faqTechnicalHelpAnswers: {
      'To login to the Online Credit Center you need a browser which is SSL...':
        'To login to the Online Credit Center you need a browser which is SSL-compliant and has a “secure mode.” When your browser is in secure mode you will notice an unbroken key or lock at the bottom of the page. If you are accessing the Online Credit Center with a browser that is not SSL-compliant or has a “secure mode,” you may not be able to log in or view your account information. Please download the latest version of Chrome, Edge or Safari browser for the best experience.',
      'The Online Credit Center may be down for maintenance...':
        'The Online Credit Center may be down for maintenance purposes daily between midnight and 6 AM EST.'
    },
    faqInterestQuestions: {
      'How can I avoid interest charges?': 'How can I avoid interest charges?',
      'How can I avoid late payment fees?': 'How can I avoid late payment fees?'
    },
    faqInterestAnswers: {
      'If there is no previous balance for the billing period...':
        'If there is no previous balance for the billing period or the sum of your payments and credits for the billing period is at least equal to the previous balance, new purchases and other charges will not incur an interest charge in the billing period when they are made or if they are paid by the due date shown on your statement.',
      'You will not be charged a late payment fee if we receive...':
        'You will not be charged a late payment fee if we receive at least the minimum payment by the payment due date shown on your statement'
    },
    faqWebPageIssueQuestions: {
      'What should I do when I am having trouble viewing my account information on the screen?':
        'What should I do when I am having trouble viewing my account information on the screen?'
    },
    faqWebPageIssueAnswers: {
      'Please try one or more of the following to resolve the issue:':
        'Please try one or more of the following to resolve the issue:',
      'Press F5 to refresh your browser': 'Press F5 to refresh your browser',
      'Check that the browser you are using is compatible (see Technical Help)':
        'Check that the browser you are using is compatible (see Technical Help)',
      'Ensure that pop-up blocker is disabled while on this web site':
        'Ensure that pop-up blocker is disabled while on this web site',
      'Check your internet connection to ensure it is functioning properly':
        'Check your internet connection to ensure it is functioning properly',
      'If you are still encountering problems after trying the above actions...':
        'If you are still encountering problems after trying the above actions, please contact our Customer Service department and notify them of any problems that you are having in viewing account information by calling %customerCare% Monday-Friday 8AM - 1AM EST and Saturday-Sunday 9AM – 10PM EST.'
    },
    faqCloseAccountQuestions: {
      'What happens if I choose to close my account?':
        'What happens if I choose to close my account?'
    },
    faqCloseAccountAnswers: {
      'You are a valued customer and we hope you...':
        'You are a valued customer and we hope you will choose not to close your account. At your request we will close your account and report your decision to the credit reporting agencies as “Closed by customer request”. Remember that both you and any Personal Guarantor are still responsible for any remaining balance on the account.'
    },
    faqContactUsQuestions: {
      'Customer Service/Account Information':
        'Customer Service/Account Information'
    },
    faqContactUsAnswers: {
      'For questions regarding Customer Service or Account Information...':
        'For questions regarding Customer Service or Account Information please call Customer Service at %customerCare%.',
      'We are available Monday-Friday 8AM - 1AM EST and...':
        'We are available Monday-Friday 8AM - 1AM EST and Saturday-Sunday 9AM – 10PM EST.'
    },
    faqUpdateAccountInformationQuestions: {
      'How do I update my mailing address and/or phone number?':
        'How do I update my mailing address and/or phone number?'
    },
    faqUpdateAccountInformationAnswers: {
      "You can update your company's mailing address...": `You can update your company's mailing address and phone number by selecting “Edit Business Information” under the “Account Management” section.`,
      'Legal Name Change': 'Legal Name Change',
      "To change the company's legal name...": `To change the company's legal name on the account contact Customer Service at 1-855-659-9789. We are available Monday-Friday 8AM - 1AM EST and Saturday-Sunday 9AM – 10PM EST.`,
      'Please mail a copy of the legal documents...':
        'Please mail a copy of the legal documents to the following address, in order to process your request:',
      'General Inquiry Name Change': 'General Inquiry Name Change'
    },
    faqAccountActivityQuestions: {
      'How do I obtain proof of purchase documentation?':
        ' How do I obtain proof of purchase documentation?',
      'How do I view and print my past account activity?':
        'How do I view and print my past account activity?',
      'How can I download Statements?': 'How can I download Statements?'
    },
    faqAccountActivityAnswers: {
      'Under the “Billing” section select...':
        'Under the “Billing” section select “Transactions” or “eStatements” to view and print details for transactions made within the past 6 months. The details will include the date of purchases, purchase description and much more.',
      'Select “Billing” at the top of the page':
        'Select “Billing” at the top of the page',
      'Select “eStatements”  and choose the statement you wish to view/download':
        'Select “eStatements”  and choose the statement you wish to view/download',
      'Select the desired “Statement Date”':
        'Select the desired “Statement Date”',
      'Select the “PDF” button': 'Select the “PDF” button'
    },
    faqReplacementCardsQuestions: {
      'What should I do if my credit card has been lost or stolen?':
        'What should I do if my credit card has been lost or stolen?',
      'What should I do if my credit card has been damaged?':
        'What should I do if my credit card has been damaged?',
      'What should I do if I have not received my replacement card?':
        'What should I do if I have not received my replacement card?'
    },
    faqReplacementCardsAnswers: {
      'You can report your card lost, misplaced...':
        'You can report your card lost, misplaced, or stolen online by selecting “Request Cards for Additional Buyers” under the “Account Management” section, and then select the “Report a lost or stolen card.” Please review your account for any purchase you did not make. If you see any unauthorized charges please call Customer Service immediately at %customerCare%.',
      'You can request a replacement card...':
        'You can request a replacement card by selecting “Request Cards for Additional Buyers” under the “Account Management” section, then follow the instructions to request new cards for additional buyers. Or you may call Customer Service at %customerCare%.',
      'Contact Customer Service at...':
        'Contact Customer Service at %customerCare%.'
    },
    faqSecurityInformationQuestions: {
      'Am I on a secure site even if the padlock on my browser is not locked?':
        'Am I on a secure site even if the padlock on my browser is not locked?',
      'What is SSL?': 'What is SSL?',
      'What is a "secure session" and how does it help keep my information safe?':
        'What is a "secure session" and how does it help keep my information safe?',
      'What should I do when I have finished viewing my account information?':
        'What should I do when I have finished viewing my account information?',
      'What should I do if I am using a "public" computer?':
        'What should I do if I am using a "public" computer?',
      'How can I tell when my connection is secure?':
        'How can I tell when my connection is secure?'
    },
    faqSecurityInformationAnswers: {
      'Your account information, credit application and other sensitive...':
        'Your account information, credit application and other sensitive information is being encrypted on the Online Credit Center. An encrypted item is scrambled so that no one between your computer and Synchrony Bank (SYNCB) can read the message or information you entered.',
      'The reason the padlock icon provided on your browser may...':
        'The reason the padlock icon provided on your browser may not appear locked (symbolizing an encrypted session) is because the Online Credit Center may use multiple frames to display information on your computer. The graphical header and navigation bar across the top of your screen may be one frame. The selections that appear on the left are another frame. The main portion of the site appears in the remaining frame. Frames that display general information about the site, such as the navigation bar across the top of your screen, are not encrypted. However, any screen that displays or requests information about your account, user name, passcode, application and other sensitive information is encrypted.',
      'SSL is an abbreviation for Secured Socket...': `SSL is an abbreviation for Secured Socket Layer. SSL technology secretly encodes (or encrypts) information as it is being sent over the Internet between your computer and SYNCB's systems. This encryption technology helps ensure that your account information travels securely over the internet and remains confidential.`,
      'During a secure SSL (Secured Socket Layer) session...': `During a secure SSL (Secured Socket Layer) session, data traveling between your computer and SYNCB's systems is secured using encryption technology. This SSL technology secretly encodes your information to create a private conversation that only your computer and SYNCB's systems can understand.`,
      'When you have finished using a secure area of Online Credit Center...':
        'When you have finished using a secure area of Online Credit Center¸ make sure you close/exit the internet browser software (e.g. Chrome, Edge, Firefox, Internet Explorer, AOL). This will decrease the possibility of anyone viewing confidential account information.',
      'If you use a computer that others also work on...':
        'If you use a computer that others also work on and you are uncomfortable that they may view "cached" pages after you have left the station, you should close/exit the internet browser software (e.g. Chrome, Edge, Firefox, Internet Explorer, AOL) before leaving. This will decrease the possibility of anyone viewing confidential account information.',
      'To confirm that your information is encrypted perform the following three steps:':
        'To confirm that your information is encrypted perform the following three steps:',
      'Place your cursor on an area of screen where...':
        'Place your cursor on an area of screen where confidential information is being displayed.',
      'With a Chrome browser, right-click to the left...':
        'With a Chrome browser, right-click to the left of the web address in the top left corner of the screen',
      "With an Internet Explorer browser, right-click, select 'Properties'.": `With an Internet Explorer browser, right-click, select ‘Properties'.`,
      'With a Firefox browser, right-click, select...': `With a Firefox browser, right-click, select ‘View Frame Info'’ or select ‘View’ | ‘Page Frame Info’ from the browser menu bar.`,
      'For Macintosh users¸ Ctrl-click¸ select...': `For Macintosh users¸ Ctrl-click¸ select ‘New Window with this Frame’ OR select ‘View’ | ‘Page Info’ from the browser menu bar. Check the Web address that you have accessed. If you are in a secure area, the address will appear as https://www. Notice the “s” in the address. This means that you have accessed a secure server.`
    },
    faqCreditQuestions: {
      'Credit Bureau Questions/Disputes': 'Credit Bureau Questions/Disputes',
      'How do I increase my available credit online?':
        'How do I increase my available credit online?'
    },
    faqCreditAnswers: {
      'If you believe that we have reported inaccurate information about you to a customer...':
        'If you believe that we have reported inaccurate information about you to a customer reporting agency, please contact customer service at %customerCare% or write to us at the following address:',
      'General Inquiry Credit Bureau Dispute':
        'General Inquiry Credit Bureau Dispute',
      'In doing so, please identify the accurate information...':
        'In doing so, please identify the accurate information and tell us why you believe it is incorrect. If you have a copy of the credit report that includes the accurate information, please send a copy of that report to us as well.',
      'You can request an increase to your available credit...':
        'You can request an increase to your available credit online by selecting “Account Management” and then under “Request Credit Line Increase” follow the instructions. Please be advised that your application for an increase is not considered received until you click the Submit button at the end of the process.'
    },
    faqOnlineMessageCenterQuestions: {
      'What is the Online Message Center?':
        'What is the Online Message Center?',
      'How can I view responses to my requests or inquiries?':
        'How can I view responses to my requests or inquiries?',
      'Is the information I submit through the Online Message Center secure?':
        'Is the information I submit through the Online Message Center secure?',
      'What type of questions can I submit through the Online Message Center?':
        'What type of questions can I submit through the Online Message Center?'
    },
    faqOnlineMessageCenterAnswers: {
      'The Online Message Center provides a secure...':
        'The Online Message Center provides a secure online method for you to send requests or inquiries about your account to Customer Service. To access the Online Message Center click on “send us a secure message”.',
      'Responses to your inquiries can only be viewed...':
        'Responses to your inquiries can only be viewed through the Online Message Center. You will be sent a notice to your personal email address upon receipt of your inquiry and when a response is posted.',
      'Yes. Information submitted through the Online Message...':
        'Yes. Information submitted through the Online Message Center is secure and safe. This service is only accessible through the Online Credit Center.',
      'The Online Message Center should be used for questions concerning:':
        'The Online Message Center should be used for questions concerning:',
      'Account Information': 'Account Information',
      'Available Credit, Receipt of Payment':
        'Available Credit, Receipt of Payment',
      'Account Maintenance': 'Account Maintenance',
      'Current Balance, Credit Line Increase, Lost/Stolen Card':
        'Current Balance, Credit Line Increase, Lost/Stolen Card, Replacement Credit Card, Name/Address Change, Add/Remove Authorized User',
      'Billing Inquiries': 'Billing Inquiries',
      'Billing Date, Payments, Late Fees, Credit Balance Inquiry':
        'Billing Date, Payments, Late Fees, Credit Balance Inquiry',
      Disputes: 'Disputes',
      'Purchase Dispute': 'Purchase Dispute',
      'Technical Support, eStatements, Payments, Password/Login Issues':
        'Technical Support, eStatements, Payments, Password/Login Issues',
      Other: 'Other'
    }
  },
  es: {
    registration: { pageTitle: '' }
  }
}
